import { createSlice } from "@reduxjs/toolkit";
// import { getAllThemeList } from "./ThunkActions";
import { getLockAmount } from "./ThunkAction";
import { iThemeState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iThemeState = {
  isLoading: false,
  lockAmountList:[],
  errorMessage: null,
};
export const addLockAmountSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetLockAmountState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLockAmount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLockAmount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.lockAmountList = action.payload?.data || [];
      })
      .addCase(getLockAmount.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = "Failed to fetch data";
      });
  },
});


export const { resetLockAmountState } = addLockAmountSlice.actions;
export default addLockAmountSlice.reducer;
